module.exports = {"yytx24":{"daobanList":[{"title":"1:是否办理出租屋综合税缴纳","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、A06913《财产和行为税纳税申报表》","state":"必要"},{"name":"2、A06914《财产和行为税减免税明细申报附表》","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx24.json
// module id = 1322
// module chunks = 0